import {
    CANDIDATE_REPORT,
    CANDIDATE_REPORT_SUCCESSFUL,
    CANDIDATE_REPORT_FAILED,CANDIDATE_REPORT_DOWNLOAD,
    CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL,
    CANDIDATE_REPORT_DOWNLOAD_FAILED,
  } from "./actionType"
  
  const initialState = {
    candidateMasterDetails: null,
    candidateMasterDetailsError: null,
    candidateDownloadReport:null,
    candidateDownloadReportError:null,
    loading: false,
  }
  
  const reportReducer = (state = initialState, action) => {
    switch (action.type) { 
      case CANDIDATE_REPORT:
        state = {
          ...state,
          loading: true,
          candidateMasterDetails: null,
          candidateMasterDetailsError: null,
        }
        break
      case CANDIDATE_REPORT_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          candidateMasterDetails: action.payload,
          candidateMasterDetailsError: null,
        }
        break
      case CANDIDATE_REPORT_FAILED:
       
        state = {
          ...state,
          candidateMasterDetails: null,
          loading: false,
          candidateMasterDetailsError: action.payload,
        }
        break
  
        case CANDIDATE_REPORT_DOWNLOAD:
        state = {
          ...state,
          loading: true,
          candidateDownloadReport:null,
          candidateDownloadReportError: null,
        }
        break
      case CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          candidateDownloadReport: action.payload,
          candidateDownloadReportError: null,
        }
        break
      case CANDIDATE_REPORT_DOWNLOAD_FAILED:
       
        state = {
          ...state,
          candidateDownloadReport: null,
          loading: false,
          candidateDownloadReportError: action.payload,
        }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reportReducer
  